<template lang="html">
  <div class="vh-100 overflow-y-scroll pa4">
    <div class="ma2 row">
      <pl-button @click.native="$router.go(-1)" class="pl-primary">
        < GO BACK
      </pl-button>
    </div>

    <!-- <div class="dank-banner shadow-1" :style="image_source"/> -->

    <!-- Search -->
    <div class="mt4">
      <span class="pl-title mb4">Collections</span>
      <div class="row mt3">
        <pl-input
          ref="input-native-tag"
          class="default col-xs-12 col-sm-8 col-md-6 col-lg-4"
          :addon="addon"
          :placeholder="placeholder"
          v-model="searchCollection"
          @input="search"
        />
        <pl-button @click.native="createNewCollection" class="pl-primary">
          CREATE NEW COLLECTION
        </pl-button>
      </div>
    </div>

    <!-- Collections -->
    <div class="pv2">
      <span class="ml1 pl-color-ruby"
        >(a position of 0 will exclude it from the universe home page)</span
      >
      <ul class="row ph4">
        <li
          v-for="category in categories"
          :key="category.name"
          class="col-xs-12 col-sm-8 col-md-6 col-lg-4"
        >
          <span class="pl-title">{{ category.name }}</span>
          <pl-button
            @click.native="editCategory(category.id)"
            class="pl-small pl-icon"
          >
            <i class="fas fa-edit"></i>
          </pl-button>
          <pl-button
            @click.native="deleteCategory(category.id)"
            class="pl-small pl-icon"
          >
            <i class="fas fa-remove"></i>
          </pl-button>
          <br />

          <!-- Edit Category Position -->
          <span>Default Position:</span>
          <select
            @change="editCategoryPosition(category.id, $event)"
            v-model="category.position"
          >
            <option
              :value="index"
              :key="category.name + index"
              v-for="(position, index) in categories.length + 1"
            >
              {{ index }}
            </option>
          </select>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import { EventBus } from 'utils/event-bus';
  import adminServices from 'services/admin/adminServices';

  export default {
    data() {
      return {
        addon: 'search',
        placeholder: 'Search Collections',
        searchCollection: '',
        new_category: '',
        categories: [],
        allCategories: [],
      };
    },
    methods: {
      createNewCollection() {
        const new_category_name = prompt('What is the new collection name?');
        if (new_category_name) {
          adminServices
            .createUniverseCategory(new_category_name)
            .then((category) => {
              this.categories.push(category.data);
            })
            .catch(console.error);
        }
      },
      editCategory(category_id) {
        let routeData = this.$router.resolve({
          name: `admin-edit-collection/${category_id}`,
        });
        window.open(routeData.resolved.name, '_blank');
      },
      deleteCategory(category_id) {
        const has_confirmed = confirm(
          'Are you sure you would like to delete this collection? All Roundtables In the universe will be dissasociated with this collection'
        );
        if (has_confirmed) {
          adminServices
            .deleteUniverseCategory(category_id)
            .then(() => {
              const index = this.categories.findIndex(
                (el) => el.id === category_id
              );
              this.categories.splice(index, 1);
            })
            .catch(console.log);
        }
      },
      editCategoryPosition(category_id, event) {
        adminServices
          .editUniverseCategory(category_id, { position: event.target.value })
          .then(() => {
            EventBus.$emit('toast-msg', 'Changes saved!');
          })
          .catch(console.error);
      },
      loadCollections() {
        this.$store.dispatch('getAllUniverseCategories').then((results) => {
          this.allCategories = results;
          this.categories = results;
        });
      },
      search(ev) {
        this.categories = this.allCategories.filter((c) =>
          c.name.toLowerCase().includes(ev.toLowerCase())
        );
      },
    },
    mounted() {
      this.loadCollections();
    },
  };
</script>

<style scoped lang="stylus">
  .pl-title {
    font-weight: bold;
    font-size: 24px;
    margin-top: 2rem;
  }

  .ma2 .pl-primary.pl-primary {
    background-color: #fff;
    color: #72ccd7;
    font-weight: bold;

    &:hover {
      background-color: #fff;
      color: #72ccd7;
    }
  }
  .mt4 .pl-primary.pl-primary {
    background-color: #fff;
    color: #000;
    font-weight: bold;
    min-width: 320px;
    font-size: 18px;
    min-height: 46px;
    margin: 0 0.55rem 0 2.55rem
    &:hover {
      background-color: #fff;
      color: #000;
    }
  }

  .input-container {
    border-radius: 25px;
  }
</style>



// WEBPACK FOOTER //
// adminManageCollections.vue?82b7a318